export default {
  Codigo: null,
  CodigoCotizacion: null,
  ItemProducto: null,
  CodigoEspecificacionTecnica: null,
  Descripcion: null,
  Cantidad: null,
  Repeticion: null,
  CantidadBocas: null,
};
